export default "__VITE_ASSET__20e79de5__"